import Dexie from 'dexie'

const db = new Dexie('Escape_DB')

db.version(1).stores({
  charts:'++id,name',
  data:'++id,chartId,ts,value,memo',
  users:'++id,name,pin'
})

export default db